import ViewPadrao from "../views/ViewPadrao";
import EquipamentoList from "../views/EquipamentoList";
import EquipamentoCad from "../views/EquipamentoCad";

export default {
  path: "equipamento",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "equipamento-list",
      component: EquipamentoList,
    },
    {
      path: "novo",
      name: "equipamento-formulario",
      component: EquipamentoCad,
    },
    {
      path: "editar/:id",
      name: "equipamento-formulario-editar",
      component: EquipamentoCad,
    },
  ],
};
